import { Compass, Hammer, Rocket, TrendingUp } from "lucide-react";

const steps = [
  {
    icon: Compass,
    n: "01",
    t: "Discover",
    d: "Deep audit of your business, users, and stack. We surface the highest-leverage growth bets before a single pixel ships.",
  },
  {
    icon: Hammer,
    n: "02",
    t: "Build",
    d: "Senior engineers + designers ship in weekly cycles. You get demos, code, and decisions — never a black box.",
  },
  {
    icon: Rocket,
    n: "03",
    t: "Launch",
    d: "We go live with measurement baked in: analytics, A/B infra, monitoring. Day-one data, not vanity metrics.",
  },
  {
    icon: TrendingUp,
    n: "04",
    t: "Scale",
    d: "Continuous CRO, automation, and content compounding — every month moves the needle on revenue, not just traffic.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-16 md:py-24 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal max-w-3xl mb-10 md:mb-14">
          <div className="text-xs font-bold tracking-[0.22em] uppercase text-[#00F0FF]">
            / Process
          </div>
          <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold leading-[0.95] tracking-[-0.03em]">
            From idea to revenue,
            <br />
            <span className="text-slate-500">in four moves.</span>
          </h2>
        </div>

        <div className="relative">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#007AFF]/40 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {steps.map((s, i) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="reveal group relative"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="relative grid place-items-center h-24 w-24 rounded-3xl bg-[#0A0F1C] border border-white/10 mb-7 group-hover:border-[#007AFF]/50 transition-colors">
                  <s.icon className="h-9 w-9 text-[#00F0FF]" />
                  <span className="absolute -top-3 -right-3 grid place-items-center h-8 w-8 rounded-full bg-[#007AFF] text-white text-xs font-bold font-mono-clean">
                    {s.n}
                  </span>
                </div>
                <h3 className="font-display text-2xl font-bold tracking-tight">
                  {s.t}
                </h3>
                <p className="mt-3 text-slate-400 leading-relaxed text-[15px]">
                  {s.d}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
